import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { InfoTable } from '@myplay/ui';

import MyTeamsTableItem from './MyTeamsTableItem';
import sort from '../../utils/sort';
import { NAME, SEASON, HIGHLIGHTS_COUNT, VIDEOS_COUNT } from '../../utils/constants';
import "./MyTeamsTable.scss";

const MyTeamsTable = ({ headers, tableItems, onSelectTeam, onDeleteTeam }) => {
  const [ sortedTableItems, setSortedItems ] = useState([]);
  const [ isDesc, setIsDesc ] = useState(false);
  const [ sortedBy, setSortedBy ] = useState("");

  useEffect(()=> {
    setSortedItems([ ...tableItems ])
  }, [ tableItems ] );
  
  const handleHeaderClick = header => {
    let sorted = [];
    switch (header) {
      case "Team":
        sorted = [...sort(sortedTableItems, NAME)];
        break;
      case "Sport": 
        sorted = [...sort(sortedTableItems, "category.name")];
        break;
      case "Season": 
        sorted = [...sort(sortedTableItems, SEASON)];
        break;
      case "Coaches":
        sorted = [...sort(sortedTableItems, "members.coaches.fullName")];
        break;
      case "Videos":
        sorted = [...sort(sortedTableItems, VIDEOS_COUNT)];
        break;
      case "Highlights":
        sorted = [...sort(sortedTableItems, HIGHLIGHTS_COUNT)]; 
        break;
      case "Members":
        sorted = [...sort(sortedTableItems, "members.players.length")];
        break;
      default: return;
    }

    if (isDesc) {
      sorted.reverse();
    };
    setIsDesc(!isDesc);
    setSortedItems([...sorted]);
    setSortedBy(header);
  }

  const handleDeleteTeam = (team, event) => {
    event.stopPropagation();  
    onDeleteTeam(team);
  };

  return (
    <div className="my-teams-table" data-testid="my-teams-table">
      <InfoTable 
        headers={headers}
        gridTemplateColumns="15% 7% 7% 28% 7% 7% 7% 11% auto"
        onChildClick={onSelectTeam}
        onHeaderClick={handleHeaderClick}
        sortedBy={sortedBy}
        isDesc={isDesc}
      >
        {sortedTableItems.map(item => <MyTeamsTableItem {...item} onDelete={event => handleDeleteTeam(item, event)}/>)}
      </InfoTable>
    </div>
  );
};

MyTeamsTable.propTypes = {
  headers: PropTypes.array,
  tableItems: PropTypes.array
};

MyTeamsTable.defaultProps = {
  headers: [],
  tableItems: []
};

export default MyTeamsTable;